export default function({ route, from }: any) {
  if (from && from.name === '__parking') {
    return new Promise(() => {
      window.location.replace(route.fullPath)
    })
  }
}
